export enum FeatureFlag {
  SPOTTARIF = 'rechnungen-show_spot_tariff',
  SUBUSER = 'subusers-enable_registration',
  UMMELDUNG = 'zaehlpunkte-enable_ummeldung',
  UMMELDUNG_NEW = 'enable_ummeldung',
  CONSUMPTION = 'zaehlpunkt_details-enable_verbrauch_export',
  METERPOINTS_EXPORT = 'zaehlpunkte-enable_export',
  RECHNUNG_REKLAMIEREN = 'rechnungen-enable_reklamation',
  RECHNUNG_ENABLE_DOWNLOAD = 'rechnungen-enable_download',
  RECHNUNG_USE_V2_VIEW = 'rechnungen-use_rechnung_v2_view',
  PRODUKTBERATUNG = 'produktberatung-enable',
}
